export default "__VITE_ASSET__BvysSoRh__"